"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatEmfMetric = void 0;
var atoz_shiftapp_initializer_1 = require("@amzn/atoz-shiftapp-initializer");
/**
 * Given metric keys/values and dimensions, returns an object formatted
 * within the AWS EMF spec to be logged to CloudWatch
 *
 * See https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch_Embedded_Metric_Format_Specification.html
 */
var formatEmfMetric = function (_a) {
    var _b;
    var _c;
    var metricName = _a.metricName, metricValue = _a.metricValue, metricUnit = _a.metricUnit, dimensions = _a.dimensions, _d = _a.namespace, namespace = _d === void 0 ? 'AtoZShiftManagementApp' : _d, context = _a.context;
    // TODO: determine pathname on native without DOM APIs
    var currentPath = typeof window !== undefined ? (_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.pathname : 'unknown';
    var pageName = (0, atoz_shiftapp_initializer_1.getRouteFromPath)(currentPath);
    var allDimensions = __assign({ PageName: pageName }, dimensions);
    return __assign(__assign({ _aws: {
            // eslint-disable-next-line no-restricted-globals
            Timestamp: Date.now(),
            CloudWatchMetrics: [
                {
                    Namespace: namespace,
                    Dimensions: Object.keys(allDimensions).map(function (d) { return [d]; }),
                    Metrics: [
                        {
                            Name: metricName,
                            Unit: metricUnit
                        }
                    ]
                }
            ]
        } }, allDimensions), (_b = {}, _b[metricName] = metricValue, _b.Context = context, _b));
};
exports.formatEmfMetric = formatEmfMetric;
